import React, { useState } from 'react'
import { Button, Tooltip } from 'antd'
import { Offer } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import OfferDetailsModal from './OfferDetailsModal/OfferDetailsModal'

const OffersActionColumn: React.FC<{ offer: Offer }> = ({ offer }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  return <>
    <Tooltip title={t('Offers.ShowOffer')} color='blue'>
      <Button
        type='ghost'
        shape='circle'
        icon={<EyeOutlined />}
        onClick={() => setIsModalVisible(true)}
      />
    </Tooltip>
    <OfferDetailsModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      offer={offer}
    />
  </>
}

export default OffersActionColumn
